import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles()((theme: Theme) => ({
  card: {
    boxSizing: 'border-box',
    width: '100%',
    flex: 1,
    minHeight: 0,
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.dividerV2.main}`,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    [theme.breakpoints.down('lg')]: {
      flex: 'unset',
      minHeight: '60vh',
    },
  },
  tableFill: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    '& > *': {
      flex: 1,
      minHeight: 0,
    },
    '& table': {
      tableLayout: 'fixed',
      width: '100%',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 24px 0 12px',
    boxShadow: `inset 0px -1px 0px 0px ${theme.palette.dividerV2.main}`,
  },
  tabs: {
    display: 'flex',
    alignItems: 'center',
  },
  tab: {
    position: 'relative',
    padding: '14px 12px',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraText.description,
    whiteSpace: 'nowrap',
  },
  tabActive: {
    color: theme.palette.labraText.primary,
    '&::after': {
      content: '""',
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      height: 4,
      backgroundColor: theme.palette.loading.main,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flexShrink: 0,
    // The shared Filters funnel renders its own trigger; give it the same
    // grey rounded-square treatment as the sort button (Figma toolbar).
    '& [data-testid="filter-icon"]': {
      boxSizing: 'border-box',
      width: 28,
      minWidth: 28,
      height: 28,
      padding: 0,
      borderRadius: 4,
      backgroundColor: theme.palette.bgSecondary.main,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& > *': {
        padding: 0,
        margin: 0,
      },
      '& svg': {
        width: 16,
        height: 16,
        fontSize: 16,
      },
    },
  },
  toolbarDivider: {
    width: 1,
    height: 22,
    backgroundColor: theme.palette.dividerV2.main,
    flexShrink: 0,
  },
  toolbarBtn: {
    width: 28,
    height: 28,
    padding: 0,
    border: 'none',
    borderRadius: 4,
    backgroundColor: theme.palette.bgSecondary.main,
    color: theme.palette.labraText.description,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '& svg': {
      fontSize: 16,
    },
  },
  muted: {
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
  },
  amountCell: {
    display: 'inline-flex',
    alignItems: 'flex-end',
    gap: 4,
  },
  amountSymbol: {
    fontSize: 12,
    lineHeight: '16px',
    color: theme.palette.labraText.description,
  },
  amountValue: {
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.tertiary,
    whiteSpace: 'nowrap',
  },
  expiryCell: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    whiteSpace: 'nowrap',
    // Inner MUI Typography would otherwise reset to its 16px body variant and
    // its own text color; inherit both so `expiryUrgent` can tint the row red.
    '& .MuiTypography-root': {
      fontSize: 14,
      lineHeight: '20px',
      letterSpacing: '0.25px',
      color: 'inherit',
    },
    '& svg': {
      fontSize: 12,
    },
  },
  expiryUrgent: {
    color: theme.palette.error.dark,
  },
  expiryDate: {
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.tertiary,
    whiteSpace: 'nowrap',
  },
  nextCell: {
    // Anchors the hover button, which overlays the summary rather than taking a
    // slice of the column from it.
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    minWidth: 0,
  },
  nextText: {
    flex: '1 1 auto',
    minWidth: 0,
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  // Carries the positioning and the hover toggle so the tooltip's own wrapper
  // stays out of the layout: floated over the end of the summary rather than
  // sitting beside it, so the text gets the full column width and the row never
  // reflows on hover.
  aiBtnWrap: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1,
    display: 'flex',
    visibility: 'hidden',
    'tr:hover &, .MuiTableRow-root:hover &': {
      visibility: 'visible',
    },
  },
  aiBtn: {
    width: 28,
    height: 28,
    padding: 6,
    borderRadius: 8,
    border: `1px solid ${theme.palette.inputBorder.main}`,
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  aiIcon: {
    width: 12,
    height: 12,
  },
}))
